'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes'),
    ImageAPI = require('../api/ImageAPI'),
    ActionUtils = require('../utils/ActionUtils'),
    GrabbagImageStore = require('../stores/GrabbagImageStore'),
    ImageUsedInStampStore = require('../stores/ImageUsedInStampStore'),
    handleUnauthAction = require('../utils/handleUnauthAction'),
    AnalyticsSources = require('../constants/AnalyticsSources');

var ImageActionCreators = {
  addToGrabbag(uuid, stampId) {
    if (handleUnauthAction(AnalyticsSources.IMAGE_CONTROLS)) {
      return;
    }

    AppDispatcher.handleViewAction({
      type: ActionTypes.IMAGE_ADD_TO_GRABBAG,
      uuid: uuid
    });

    ImageAPI.addToGrabbag(uuid, stampId);
  },

  requestGrabbagImagesPage(tab, isInitialRequest) {
    ActionUtils.requestIndexedPage({
      tab: tab,
      idAttribute: 'tab',
      isInitialRequest: isInitialRequest,
      store: GrabbagImageStore,
      action: ActionTypes.REQUEST_GRABBAG_IMAGES,
      callAPI: ImageAPI.requestGrabbagImagesPage
    });
  },

  removeFromGrabbag(uuid) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.IMAGE_REMOVE_FROM_GRABBAG,
      uuid: uuid
    });

    ImageAPI.removeFromGrabbag(uuid);
  },

  removeStampletItem(uuid) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.IMAGE_REMOVE_STAMPLET_ITEM,
      uuid: uuid
    });

    ImageAPI.removeStampletItem(uuid);
  },

  requestImageUsedInStampsPage(imageUuid, isInitialRequest) {
    ActionUtils.requestIndexedPage({
      imageUuid: imageUuid,
      idAttribute: 'imageUuid',
      isInitialRequest: isInitialRequest,
      store: ImageUsedInStampStore,
      action: ActionTypes.REQUEST_IMAGE_USED_IN_STAMPS,
      callAPI: ImageAPI.requestImageUsedInStampsPage
    });
  }
};

module.exports = ImageActionCreators;


/** WEBPACK FOOTER **
 ** ./actions/ImageActionCreators.js
 **/